const LOGIN_FLAG_KEY = "qywx_login_flag"
const LOGIN_USER_ID_KEY = "qywx_login_user_id"

function safeStorage(type = "local") {
  try {
    return type === "session" ? window.sessionStorage : window.localStorage
  } catch (e) {
    return null
  }
}

export function getLoginUserId() {
  const local = safeStorage("local")
  const session = safeStorage("session")
  return (
    (local && local.getItem(LOGIN_USER_ID_KEY)) ||
    (session && session.getItem(LOGIN_USER_ID_KEY)) ||
    ""
  )
}

export function isLoggedIn() {
  return !!getLoginUserId()
}

export function saveLoginUserId(userId) {
  const local = safeStorage("local")
  const session = safeStorage("session")
  const uid = userId ? String(userId) : ""
  if (!uid) return
  if (local) {
    local.setItem(LOGIN_FLAG_KEY, "1")
    local.setItem(LOGIN_USER_ID_KEY, uid)
  }
  if (session) {
    session.setItem(LOGIN_FLAG_KEY, "1")
    session.setItem(LOGIN_USER_ID_KEY, uid)
  }
}

export function clearLoginResult() {
  const local = safeStorage("local")
  const session = safeStorage("session")
  if (local) {
    local.removeItem(LOGIN_FLAG_KEY)
    local.removeItem(LOGIN_USER_ID_KEY)
  }
  if (session) {
    session.removeItem(LOGIN_FLAG_KEY)
    session.removeItem(LOGIN_USER_ID_KEY)
  }
}

